import React from 'react'
import CSSModules from 'react-css-modules'

import styles from './loading-spinner.css'

import SpinnerIcon from '../../../assets/icons/spinner.svg'

const LoadingSpinner = () => (
  <div styleName="loading-spinner">
    <SpinnerIcon />
  </div>
)

export default CSSModules(LoadingSpinner, styles)



/** WEBPACK FOOTER **
 ** ./src/components/loading-spinner/loading-spinner.js
 **/